<template>
  <v-app>
    <v-content>
      <Signature />
    </v-content>
  </v-app>
</template>

<script>
import Signature from "./components/Signature";

export default {
  name: "App",
  components: {
    Signature
  },
  data() {
    return {
      //
    };
  }
};
</script>
